import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { alertActions, breadcrumbsActions, userProjectsActions as myActions, masterProfilesActions } from "../../../_services/essentials/store";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Box, Typography, Button, Paper, Stack, Chip, Grid } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import { history } from "../../../_services/essentials/helpers";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import { IconButton, Link, Avatar, TextField, FormControl, Tooltip, } from '@mui/material';
import CircleRoundedIcon from '@mui/icons-material/CircleRounded';
import AddIcon from '@mui/icons-material/Add';
import InsightsIcon from '@mui/icons-material/Insights';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SearchIcon from '@mui/icons-material/Search';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';

import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import PropTypes from "prop-types";
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { Tab, Tabs } from "@mui/material";
// import OutlinedInput from "@mui/material/OutlinedInput";
// import InputAdornment from "@mui/material/InputAdornment";
// import Search from '_components/common/Search';
import CircularProgress from '@mui/material/CircularProgress';
import moment from 'moment';
import {NoRecordsFound} from "../../../_components/NoRecordsFound";
export { List };

function List() {
    //    const entity_name = "project";
    //    const entity_label = "Project";
    //    const entities_name = "projects";
    const entities_label = "Projects";

    const loggedInUser = useSelector(x => x.auth.loggedInUser);
    const listAPIResponse = useSelector(x => x.userProjects?.listAPIResponse);

    const [loading, setLoading] = useState(true);
    const [entities, setEntities] = useState([]);
    const [totalPages, setTotalPages] = useState('');
    const [totalItems, setTotalItems] = useState('');
    const [onLoadWait, setOnLoadWait] = useState(true);

    const statusColors = [ '#656565', '#2e7d32', '#ed6c02', '#ed6c02', '#ed6c02' ];
    const tagColors = [ '#ede7f6', '#fce4ec' ];
    const tagTextColors = [ '#673ab7', '#c2185b', '#c2185b' ];
    const topBorderColors = [ '#7c4dff', '#29b6f6', '#26a69a', '#ff7043', '#ec407a' ];
    const iconBgColors = [ '#e8eaf6', '#e1f5fe', '#e0f2f1', '#fbe9e7', '#fce4ec' ];
    const iconColors = [ '#3f51b5', '#0288d1', '#004d40', '#d84315', '#c2185b' ];
    const iconTypes = [ '', 'document', 'search' ];

    useEffect(() => {
        if (
            listAPIResponse &&
            listAPIResponse.value &&
            Array.isArray(listAPIResponse.value.list)) {
            setEntities(listAPIResponse?.value?.list);
            setTotalPages(listAPIResponse?.value?.totalPages);
            setTotalItems(listAPIResponse?.value?.totalItems);

            setLoading(false);
        }
    }, [listAPIResponse]);

    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .trim()
            .required('Required*')
            .max(60, 'Cannot exceed 60 characters'),
        description: Yup.string()
            .trim()
            .required('Required*')
            .max(250, 'Cannot exceed 250 characters'),
        geographicScope: Yup.string()
            .trim()
            .required('Required*')
            .max(60, 'Cannot exceed 60 characters'),
        keywordOrTherapeuticArea: Yup.string()
            .trim()
            .required('Required*')
            .max(60, 'Cannot exceed 60 characters'),
    });

    const formOptions = { resolver: yupResolver(validationSchema) };

    //const { register, handleSubmit, reset, formState, control } = useForm(formOptions);
    const { register, handleSubmit, reset, formState } = useForm(formOptions);

    const { errors } = formState;


    const [dataFilter, setDataFilter] = useState({
        "userProjectFilter": {
            activeStatusGroupFlag: true,
            userId: loggedInUser?.id,
            searchTerms: ""
        }
    });

    const [pageFilter, setPageFilter] = useState({
        "pageNumber": 1,
        "pageSize": 100000,
        "sortField": "status.sortOrder, lastUpdatedTime",
        "sortDirection": "asc, desc",
        "dataFilter": dataFilter
    });
    const [openCreateProjectPopup, setOpenCreateProjectPopup] = useState(false);

    const memoizedPageFilter = useMemo(() => {
        return {
            ...pageFilter,
            dataFilter: {
                ...dataFilter,
            },
        };
    }, [dataFilter]);

    dispatch(breadcrumbsActions.setCurrentURL({
        url: history.location?.pathname,
        state: history.location?.state
    }));

    useEffect(() => {
        setDataFilter({
            "userProjectFilter": {
                activeStatusGroupFlag: true,
                userId: loggedInUser?.id,
                searchTerms: ""
            }
        });
    }, [loggedInUser]);

    useEffect(() => {
        if(!onLoadWait) {
            dispatch(breadcrumbsActions.setCurrentTitle(entities_label));
            dispatch(myActions.getPaginatedList(memoizedPageFilter));
        }
    }, [pageFilter, onLoadWait ]);

    useEffect(() => {
        if(!onLoadWait) {
            dispatch(breadcrumbsActions.setCurrentTitle(entities_label));
            dispatch(myActions.getPaginatedList(memoizedPageFilter));
        }
    }, [pageFilter, onLoadWait ]);

    useEffect(() => {
        if(onLoadWait){
            const timeoutId = setTimeout(() => {
                setOnLoadWait(false);
            }, 100);

            return () => clearTimeout(timeoutId);
        }
    }, [onLoadWait]);

    function navigatePage(event, newPageNumber) {
        setPageFilter({
            ...pageFilter,
            "pageNumber": newPageNumber
        });
    }

    function showProjectProfiles(selectedUserProject) {
        //history.navigate(`/master_profiles?project_id=${selectedProjectId}`);
        history.navigate(`/master_profiles?user_projects=true`, { state: { selectedUserProject } });

    }
    function handleCreateProjectPopupClose() {
        setOpenCreateProjectPopup(false);
    }

    function CustomTabPanel(props) {
        const { children, value, backgroundColor, index, ...other } = props;

        return (
            <Box
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                minHeight={'200px'}
                sx={{ flexDirection: 'row', mb: 3 }}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index &&
                    <Stack direction="column" sx={{
                        justifyContent: 'center',
                        alignItems: 'center'
                        // background: backgroundColor,
                        // border: '0px solid #0052eb',
                        // borderColor: '#777',
                        // backdropFilter: 'blur(1px)',
                        // borderRadius: '12px'

                    }}>
                        {children}
                    </Stack>
                }
            </Box>
        );
    }

    CustomTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }
    async function downloadprofiles(event, projectId, projectName) {
        const dataFilter = {
            "masterProfileFilter": {
                projectId: projectId,
                userId: loggedInUser?.id,
                searchTerms: ""
            }
        };
        const pageFilter = {
            "pageNumber": 1,
            "pageSize": 100000, //TODO: Move this to env
            "sortField": "ranking",
            "sortDirection": "asc",
            "dataFilter": dataFilter,
            "projectName": projectName
        };

        await dispatch(masterProfilesActions.downloadprofilesByFilter(pageFilter)).unwrap();
        dispatch(myActions.getAll());
    }

    const containerRef = useRef(null);
    const [gridSpacing, setGridSpacing] = useState(2);
    const CreateProjectPopupStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 526,
        bgcolor: 'background.modal',
        // border: '2px solid #000',
        boxShadow: 24,
        borderRadius: '10px'
    };
    async function handleCreateProjectPopupOpen() {
        const newProjectEntity = {
            user: loggedInUser,
            name: "",
            description: "",
            commentAndQuestion: "",
            geographicScope: "",
            communicationMode: { "id": 1 },
            keywordOrTherapeuticArea: "",
            // privacyPolicyAcknowledgement: false,
            type: { "id": 1 },
            status: { "id": 1 }
        };
        await dispatch(myActions.getNewEntity(newProjectEntity)).unwrap();
        setOpenCreateProjectPopup(true);
    }

    async function handleCreateProjectAndAddProfiles(data) {
        const response = await dispatch(myActions.create({ data })).unwrap();
        const message = response ? response.message : '';

        if (message !== '')
            await dispatch(alertActions.success({ message, showAfterRedirect: false }));

        setOpenCreateProjectPopup(false);
        reset();
        setPageFilter({
            ...pageFilter,
            pageNumber: 1
        }
        );
        setLoading(true);

    }
    useEffect(() => {
        const container = containerRef.current;

        if (container) {
            const observer = new ResizeObserver((entries) => {
                for (let entry of entries) {
                    const { width } = entry.contentRect;
                    if (width >= 1350) {
                        setGridSpacing(2);
                    } else if (width >= 1200) {
                        setGridSpacing(6.5);
                    } else {
                        setGridSpacing(6);
                    }
                }
            });

            observer.observe(container);

            return () => observer.disconnect();
        }
    }, []);

    return (
        <Box sx={{ width: '99%', maxWidth: { sm: '100%', md: '100%' }, ml: 2 }} ref={containerRef}>
            {/* <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                {entities_label}
            </Typography> */}
            <Stack direction="row"
                sx={{ width: '100%', justifyContent: 'space-between', flexGrow: '1', gap: 1, pt: 2, pb: 2, mb: 2, border: '1px solid #E0E0E066' }} spacing={3}>
                {/* <Stack sx={{ pl: 4, width: '100%' }}>
                    <Search control={control} sx={{ width: '350px' }} handleSubmit={handleSubmit}

                    />
                </Stack> */}
                <Stack direction="row" spacing={2} sx={{ mb: 1, mt: 0.5, width: '100%', justifyContent: 'right' }} >

                    <Button onClick={() => handleCreateProjectPopupOpen()}
                        variant="contained" color="primary" size="small"
                        endIcon={<AddIcon />}>
                        Create Project
                    </Button>
                    <Stack direction="row" sx={{ ml: 8, justifyContent: 'center', alignItems: 'center' }}>
                        <Avatar
                            sx={{
                                height: 24,
                                backgroundColor: '#666fff',
                                color: '#FFF',
                                fontSize: '13px', fontWeight: 600
                            }}
                        >
                            {totalItems ? totalItems.toLocaleString() : 0}
                        </Avatar>
                        <Typography variant="body1" sx={{ ml: 0.5, mr: 1, fontWeight: 600 }}> Projects
                        </Typography>
                    </Stack>

                    <Modal
                        aria-labelledby="transition-modal-title"
                        aria-describedby="transition-modal-description"
                        open={openCreateProjectPopup}
                        onClose={handleCreateProjectPopupClose}
                        closeAfterTransition
                        slots={{ backdrop: Backdrop }}
                        slotProps={{
                            backdrop: {
                                timeout: 500,
                            },
                        }}
                    >
                        <Fade in={openCreateProjectPopup}>
                            <Box sx={CreateProjectPopupStyle}>
                                <Box sx={{}}>
                                    <Tabs
                                        value={0}

                                        indicatorColor="none"
                                        textColor="primary"
                                        sx={{
                                            ".MuiTabs-indicator": {
                                                display: "none",
                                            },

                                        }}
                                    >
                                        <Tab label="Create New Project" {...a11yProps(0)} sx={{
                                            minWidth: '100%', fontSize: '18px',
                                            fontWeight: 'bold',
                                            minHeight: 69,
                                            // background: '#efe2ba',
                                            // backdropFilter: 'blur(1px)',
                                            // borderTopLeftRadius: '12px',
                                            // borderTopRightRadius: '0px',
                                            // borderBottomRightRadius: '0px'
                                        }} />

                                    </Tabs>
                                </Box>
                                <CustomTabPanel value={0} index={0}>
                                    {!(entities?.loading || entities?.error) &&
                                        <form name="newProjectForm" id="newProjectForm" onSubmit={handleSubmit(handleCreateProjectAndAddProfiles)}>
                                            <Stack direction="column" sx={{ flexGrow: '1', gap: 1, mt: 2 }} >
                                                <Stack direction="column">
                                                    <TextField id="user" name="user" hidden type="text" value={loggedInUser?.id} {...register('user.id')} />
                                                    <TextField id="communicationMode" name="communicationMode" hidden type="text" value={1} {...register('communicationMode.id')} />
                                                    <TextField id="type" name="type" hidden type="text" value={1} {...register('type.id')} />
                                                    <TextField id="status" name="status" hidden type="text" value={1} {...register('status.id')} />
                                                    <TextField
                                                        id="commentAndQuestion"
                                                        name="commentAndQuestion"
                                                        type="text"
                                                        variant='outlined'
                                                        color='primary'
                                                        hidden
                                                        label="Additional Comments or Questions"
                                                        placeholder={""}
                                                        inputlabelprops={{ shrink: true }}
                                                        defaultValue={""}
                                                        {...register('commentAndQuestion')}
                                                    />
                                                    <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                                        <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>
                                                            Project Name<span style={{ color: 'red' }}>*</span></Typography>
                                                    </Stack>
                                                    <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                                        <TextField
                                                            id="name"
                                                            name="name"
                                                            type="text"
                                                            variant='outlined'
                                                            color='primary'
                                                            placeholder={"Project Name"}
                                                            fullWidth

                                                            sx={{ mb: 1 }}
                                                            inputlabelprops={{ shrink: true }}
                                                            defaultValue={""}
                                                            {...register('name')}
                                                            error={Boolean(errors.name)}
                                                            inputProps={{
                                                                maxLength: 60,
                                                            }}
                                                            helperText={errors.name ? errors.name.message : ""}
                                                        />
                                                    </Stack>
                                                    <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                                        <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>
                                                            Project Description<span style={{ color: 'red' }}>*</span></Typography>
                                                    </Stack>
                                                    <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                                        <TextField
                                                            id="description"
                                                            name="description"
                                                            type="text"
                                                            variant='outlined'
                                                            color='primary'
                                                            placeholder={"Project Description"}
                                                            fullWidth
                                                            multiline
                                                            size="normal"
                                                            rows={3}
                                                            sx={{
                                                                mb: 1,
                                                                '& .MuiInputBase-root': {
                                                                    height: 'auto',
                                                                    maxWidth: '95%'
                                                                },
                                                            }}
                                                            inputlabelprops={{ shrink: true }}
                                                            defaultValue={""}
                                                            {...register('description')}
                                                            inputProps={{
                                                                maxLength: 250,
                                                            }}
                                                            error={Boolean(errors.description)}
                                                            helperText={errors.description ? errors.description.message : ""}
                                                        />
                                                    </Stack>

                                                    <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                                        <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>
                                                            Keyword / Therapeutic Area / Specialty<span style={{ color: 'red' }}>*</span></Typography>
                                                    </Stack>
                                                    <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >

                                                        <TextField
                                                            id="keywordOrTherapeuticArea"
                                                            name="keywordOrTherapeuticArea"
                                                            type="text"
                                                            variant='outlined'
                                                            color='primary'
                                                            fullWidth
                                                            // label="Keyword or Therapeutic Area"
                                                            sx={{ mb: 1 }}
                                                            placeholder={"Keyword / Therapeutic Area / Specialty"}
                                                            inputlabelprops={{ shrink: true }}
                                                            defaultValue={""}
                                                            {...register('keywordOrTherapeuticArea')}
                                                            error={Boolean(errors.keywordOrTherapeuticArea)}
                                                            inputProps={{
                                                                maxLength: 60,
                                                            }}
                                                            helperText={errors.keywordOrTherapeuticArea ? errors.keywordOrTherapeuticArea.message : ""}
                                                        />
                                                    </Stack>
                                                    <Stack direction="row" sx={{ flexGrow: '1', gap: 1 }} >
                                                        <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>
                                                            Geographic Scope  <span style={{ color: 'red' }}>*</span></Typography>
                                                    </Stack>
                                                    <Stack direction="row" sx={{ flexGrow: '1' }} >

                                                        <TextField
                                                            id="geographicScope"
                                                            name="geographicScope"
                                                            type="text"
                                                            variant='outlined'
                                                            color='primary'
                                                            // label="Geographic Scope"
                                                            sx={{ mb: 1 }}
                                                            fullWidth
                                                            placeholder={"Geographic Scope"}
                                                            inputlabelprops={{ shrink: true }}
                                                            defaultValue={""}
                                                            {...register('geographicScope')}
                                                            error={Boolean(errors.geographicScope)}
                                                            helperText={errors.geographicScope ? errors.geographicScope.message : ""}
                                                            inputProps={{
                                                                maxLength: 60,
                                                            }}
                                                        />
                                                    </Stack>
                                                    <FormControl>

                                                        <Stack direction="row" spacing={2} sx={{ justifyContent: 'space-between', mt: 0.5, px: 3 }} >
                                                            <Button type={"submit"} variant="contained" color="primary" size="small"
                                                                sx={{ fontSize: 16, fontWeight: 600 }}
                                                            >
                                                                Create
                                                            </Button>
                                                            <Button onClick={() => reset()} variant="outlined" size="small"
                                                                sx={{ backgroundColor: 'buttonVar.reset', color: 'buttonVar.resetText', fontSize: 16, fontWeight: 600 }}
                                                            >
                                                                Reset
                                                            </Button>
                                                            <Button onClick={() => handleCreateProjectPopupClose()} variant="outlined"
                                                                size="small" sx={{ backgroundColor: 'buttonVar.cancel', fontSize: 16, fontWeight: 600 }}  >
                                                                Cancel
                                                            </Button>
                                                        </Stack>
                                                    </FormControl>
                                                </Stack>
                                            </Stack>
                                        </form>
                                    }
                                </CustomTabPanel>

                            </Box>
                        </Fade>
                    </Modal>
                </Stack>
            </Stack>
            {loading ? (<div
                style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    height: '80%'
                    // zIndex: 1,
                }}
            >
                <CircularProgress />
            </div>) : (
                <Grid container spacing={4}>
                    {(entities?.length > 0) && entities?.map((entity, index) => (
                    <Grid size={{ xs: 12, sm: 6, lg: 4 }} key={index}>
                        <Paper
                            elevation={0}
                            sx={{
                                borderRadius: 4,
                                border: '1px solid #eef2f6',
                                borderTop: `6px solid ${topBorderColors[(entity?.id%5)]}`,
                                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.02)',
                                overflow: 'hidden',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                minHeight: '260px',
                                bgcolor: '#fff',
                                transition: 'transform 0.2s, box-shadow 0.2s',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.05)'
                                }
                            }}
                        >
                            {/* Card Content Segment */}
                            <Box sx={{
                                p: 3,
                                cursor: 'pointer',
                                pointerEvents: (entity.status?.isActive === 0 || entity.totalProfilesAdded === 0) ? 'none' : 'auto'
                                }}
                                onClick={() => showProjectProfiles(entity)}
                            >
                                {/* Status Dot + Project Avatar Row */}
                                <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ mb: 2 }}>
                                    <Stack sx={{width: '33%'}}></Stack>
                                    <Stack sx={{width: '33%'}}>
                                        <Box
                                            sx={{
                                                width: 44,
                                                height: 44,
                                                borderRadius: 3,
                                                bgcolor: iconBgColors[(entity?.id%5)],
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: '1px solid rgba(0,0,0,0.03)'
                                            }}
                                        >
                                            {entity?.type?.id === 1 ? (
                                                <AssignmentIcon sx={{ color: iconColors[(entity?.id%5)] }} />
                                            ) : (
                                                <SearchIcon sx={{ color: iconColors[(entity?.id%5)] }} />
                                            )}
                                        </Box>
                                    </Stack>
                                    <Stack direction="row" spacing={0.5} alignItems="right" sx={{ width: '33%'}}>
                                        <FiberManualRecordIcon sx={{ color: statusColors[(entity?.status?.sortOrder%5)], fontSize: 10 }} />
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                fontWeight: 600,
                                                color: statusColors[(entity?.status?.sortOrder%5)],
                                                fontSize: '0.75rem'
                                            }}
                                        >
                                            {entity?.status?.name}
                                        </Typography>
                                    </Stack>
                                </Stack>
                                <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ mb: 2 }}>
                                    <Stack direction="row" spacing={0.5} sx={{ width: '100%', display: 'flex', justifyContent:'space-between', alignItems:'justify'}} >
                                        {/* Metadata Header Text */}
                                        <Stack direction="column">
                                            <Typography variant="subtitle1" sx={{fontWeight: 700, color: '#1a1f5e', mb: 0.5 }}>
                                                {entity?.name}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="column">
                                            <Chip
                                                id={"entity_type"}
                                                name={"entity_type"}
                                                key={entity?.type?.id}
                                                label={entity?.type?.name}
                                                color="primary" variant="outlined"
                                                sx={{backgroundColor: '#e8e6f8', mt:0.5}}
                                            />
                                        </Stack>
                                    </Stack>
                                </Stack>
                                {/* Quantity + ID Stack Node */}
                                <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
                                    <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <PeopleRoundedIcon /> {entity?.totalProfilesAdded} {entity?.totalProfilesAdded === 1 ? 'KOL' : 'KOLs'}
                                    </Typography>
                                    {/*<Typography variant="caption" sx={{ color: 'text.disabled', fontWeight: 600 }}>*/}
                                    {/*    ID {entity?.id}*/}
                                    {/*</Typography>*/}
                                </Stack>

                            {/* Textual Specific Data Layers */}
                            <Stack spacing={0.75} sx={{ mb: 2 }}>
                                <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', lineHeight: 1.4 }}>
                                    <span style={{ fontWeight: 600, color: '#444' }}>Specialty:</span> {entity?.keywordOrTherapeuticArea?.length > 0 ? (entity.keywordOrTherapeuticArea.slice(0, 25) + (entity.keywordOrTherapeuticArea.length > 25 ? "..." : ""))  : 'N/A'}
                                </Typography>
                                <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', lineHeight: 1.4 }}>
                                    <span style={{ fontWeight: 600, color: '#444' }}>Geography:</span> {entity.geographicScope ? entity.geographicScope : 'N/A'}
                                </Typography>
                                <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', lineHeight: 1.4 }}>
                                    <span style={{ fontWeight: 600, color: '#444' }}>Description:</span> {entity?.description?.length > 0 ? (entity.description.slice(0, 25) + (entity.description.length > 25 ? "..." : ""))  : 'N/A'}
                                </Typography>
                            </Stack>
                            </Box>

                            {/* Card Bottom Panel Meta Actions Area */}
                            <Box
                                sx={{
                                    p: 2.5,
                                    pt: 2,
                                    borderTop: '1px solid #f8f9fc',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    bgcolor: '#fafbfe'
                                }}
                            >
                                <Button
                                    variant="text"
                                    size="small"
                                    endIcon={<ArrowForwardIcon sx={{ fontSize: 14 }} />}
                                    sx={{
                                        textTransform: 'none',
                                        fontWeight: 700,
                                        color: '#4a3ecb',
                                        bgcolor: 'transparent',
                                        p: 1,
                                        borderRadius: 1,
                                        minWidth: 0,
                                        '&:hover': { bgcolor: '#e8e6f8', color: '#392fb4' }
                                    }}
                                    onClick={() =>
                                        history.navigate(`/user_projects/edit/${entity.id}`)
                                    }
                                >
                                    Edit Project
                                </Button>

                                <Stack direction="row" spacing={1.5} alignItems="center">
                                    {/*<Chip*/}
                                    {/*    label={entity?.id%5}*/}
                                    {/*    size="small"*/}
                                    {/*    sx={{*/}
                                    {/*        bgcolor: tagColors[entity?.id%5],*/}
                                    {/*        color: tagTextColors[entity?.id%5],*/}
                                    {/*        fontWeight: 700,*/}
                                    {/*        fontSize: '0.65rem',*/}
                                    {/*        borderRadius: 1.5,*/}
                                    {/*        height: 20*/}
                                    {/*    }}*/}
                                    {/*/>*/}
                                    <Typography variant="caption" sx={{ color: 'text.disabled', fontSize: '0.7rem', fontWeight: 500 }}>
                                        {moment(entity.lastUpdatedTime).format('DD-MM-YYYY')}
                                    </Typography>
                                </Stack>
                            </Box>
                    </Paper>
                    </Grid>
                    ))}
                </Grid>
            )
            }
            {
                (totalPages > 1) &&
                <Pagination variant="outlined" color="primary" count={totalPages} page={pageFilter.pageNumber} onChange={navigatePage} />
            }

        </Box >

    );
}
